<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white" style="padding: 32px 0;">
            <div class="d-flex align-items-center">
              <div class="header-icon-wrap mr-3">
                <i class="fe fe-activity" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">Manage Diseases</h4>
                <small style="opacity: 0.8;">
                  <span v-if="Array.isArray(diagnoses)">{{ diagnoses.length }}</span> disease(s) registered
                </small>
              </div>
            </div>
            <button class="btn btn-light btn-sm" style="border-radius: 8px; font-weight: 600;" @click="showadder = !showadder">
              <i class="fe mr-1" :class="showadder ? 'fe-x' : 'fe-plus'"></i>
              {{ showadder ? 'Close Form' : 'Add Disease' }}
            </button>
          </div>
        </div>
      </div>

      <section style="margin-top: -20px;">
        <div class="container pb-5">

          <!-- Add / Edit form -->
          <div v-show="showadder" class="card shadow-sm form-card mb-4">
            <div class="form-card-header">
              <div class="section-icon">
                <i class="fe" :class="edit ? 'fe-edit-2' : 'fe-plus'" style="font-size: 13px;"></i>
              </div>
              <h6 class="mb-0 font-weight-bold text-white">{{ edit ? 'Update Disease' : 'Add New Disease' }}</h6>
              <span v-if="edit" class="badge badge-warning ml-auto" style="border-radius: 20px; font-size: 0.75rem;">Editing</span>
            </div>
            <div class="card-body px-4 py-4">
              <div class="form-row">
                <div class="form-group col-md-8">
                  <label class="small font-weight-bold text-secondary">Disease Name <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" v-model="register.name" placeholder="e.g. Malaria" />
                </div>
                <div class="form-group col-md-4">
                  <label class="small font-weight-bold text-secondary">Type</label>
                  <select class="form-control" v-model="register.is_primary">
                    <option value="1">Primary</option>
                    <option value="0">Secondary</option>
                  </select>
                </div>
              </div>
              <div class="d-flex" style="gap: 8px;">
                <button class="btn btn-submit" @click="SubmitForm">
                  <i class="fe mr-1" :class="edit ? 'fe-save' : 'fe-send'"></i>
                  {{ edit ? 'Update Disease' : 'Add Disease' }}
                </button>
                <button v-if="edit" type="button" class="btn btn-outline-secondary" @click="edit = false; clearIt()">
                  <i class="fe fe-x mr-1"></i> Cancel
                </button>
              </div>
            </div>
          </div>

          <!-- Diseases table -->
          <div class="card shadow-sm table-card">
            <div class="d-flex align-items-center px-4 pt-4 pb-3">
              <i class="fe fe-list text-primary mr-2"></i>
              <h6 class="mb-0 font-weight-bold">Disease Registry</h6>
              <span v-if="Array.isArray(diagnoses)" class="badge badge-soft-info ml-2">{{ diagnoses.length }}</span>
            </div>
            <div class="table-responsive">
              <table class="table align-td-middle mb-0">
                <thead style="background: #f8fafc;">
                  <tr>
                    <th class="table-th">Name</th>
                    <th class="table-th">Encounters</th>
                    <th class="table-th">Type</th>
                    <th class="table-th"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="diag in diagnoses" :key="diag.id" class="table-row">
                    <td class="py-3 px-4 font-weight-bold">{{ diag.name }}</td>
                    <td class="py-3">
                      <span class="badge badge-soft-info">{{ diag.encounter_count }}</span>
                    </td>
                    <td class="py-3">
                      <span class="badge" :class="diag.is_primary == 1 ? 'badge-soft-success' : 'badge-soft-secondary'">
                        {{ diag.type || (diag.is_primary == 1 ? 'Primary' : 'Secondary') }}
                      </span>
                    </td>
                    <td class="py-3 pr-4">
                      <div class="d-flex" style="gap: 6px;">
                        <button class="btn btn-sm btn-outline-info" @click="startEdit(diag)" title="Edit">
                          <i class="fe fe-edit-2"></i>
                        </button>
                        <button class="btn btn-sm btn-outline-danger" @click="deleteDiagnosis(diag)" title="Delete">
                          <i class="fe fe-trash-2"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="!Array.isArray(diagnoses) || !diagnoses.length">
                    <td colspan="4" class="text-center py-5 text-muted">
                      <i class="fe fe-inbox" style="font-size: 2rem; opacity: 0.3;"></i>
                      <p class="mt-2 mb-0">No diseases found</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="vld-parent">
            <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
let agency = JSON.parse(localStorage.getItem("agency"));

export default {
  components: { Navbar, Loading },
  data() {
    return {
      agency: agency,
      isLoading: false,
      fullPage: true,
      showadder: false,
      edit: false,
      diagnoses: [],
      register: {
        id: "",
        name: "",
        is_primary: "",
        symptoms: "Nil",
        transmission: "Nil",
        treatment: "Nil",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    SubmitForm() {
      if (this.edit == false) {
        this.AddDisease();
      } else {
        this.updateDisease();
      }
    },
    getDiagnoses() {
      this.axios.get(`/api/v1/auth/diagnosis-agency/${agency.id}`)
        .then((response) => { this.diagnoses = response.data.data; })
        .catch((error) => { console.error(error); });
    },
    deleteDiagnosis(diag) {
      if (confirm("Are you sure?")) {
        this.axios.delete(`/api/v1/auth/diagnosis/${diag.id}`)
          .then(() => { this.getDiagnoses(); })
          .catch((error) => { console.error(error); });
      }
    },
    AddDisease() {
      this.isLoading = true;
      this.axios.post("/api/v1/auth/diagnosis", {
        agency_id: agency.id,
        is_primary: this.register.is_primary,
        name: this.register.name,
        symptoms: this.register.symptoms,
        transmission: this.register.transmission,
        treatment: this.register.treatment,
      })
      .then(() => {
        this.isLoading = false;
        this.$toasted.success("Disease added successfully!", { position: "top-right", duration: 3000 });
        this.clearIt();
        this.getDiagnoses();
        this.showadder = false;
      })
      .catch((error) => {
        console.log(error.response);
        this.isLoading = false;
        this.$toasted.error("Something went wrong", { position: "top-right", duration: 3000 });
      });
    },
    updateDisease() {
      this.isLoading = true;
      this.axios.put("/api/v1/auth/diagnosis/" + this.register.id, {
        agency_id: agency.id,
        is_primary: this.register.is_primary,
        name: this.register.name,
        symptoms: this.register.symptoms,
        transmission: this.register.transmission,
        treatment: this.register.treatment,
      })
      .then(() => {
        this.isLoading = false;
        this.edit = false;
        this.$toasted.success("Disease updated successfully!", { position: "top-right", duration: 3000 });
        this.clearIt();
        this.getDiagnoses();
        this.showadder = false;
      })
      .catch((error) => {
        console.log(error.response);
        this.isLoading = false;
        this.$toasted.error("Something went wrong", { position: "top-right", duration: 3000 });
      });
    },
    startEdit(diag) {
      this.edit = true;
      this.register.name = diag.name;
      this.register.id = diag.id;
      this.register.is_primary = diag.is_primary;
      this.showadder = true;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    clearIt() {
      this.register.name = "";
      this.register.treatment = "";
      this.register.symptoms = "";
      this.register.transmission = "";
      this.register.is_primary = "";
    },
  },
  created() {
    this.getDiagnoses();
  },
};
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  padding-bottom: 40px;
}
.header-icon-wrap {
  width: 48px;
  height: 48px;
  background: rgba(255,255,255,0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.form-card, .table-card {
  border-radius: 12px;
  border: 1px solid #e9ecef;
  overflow: hidden;
}
.form-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
}
.section-icon {
  width: 28px;
  height: 28px;
  background: rgba(255,255,255,0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
}
.table-th {
  font-size: 0.73rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  font-weight: 600;
  border-bottom: 2px solid #e2e8f0;
  padding: 12px 16px;
}
.table-row:hover { background: #f8fafc; }
.btn-submit {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border: none;
  color: #fff;
  border-radius: 8px;
  font-weight: 600;
  padding: 8px 24px;
}
.btn-submit:hover { opacity: 0.9; color: #fff; }
.form-control:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 0.15rem rgba(37,99,235,0.15);
}
</style>
